import { useEffect, useState } from "react";

import { IBatteryOutlook } from "@/features/BatteryOutlook/types";
import { config } from "@/config";
import { v1BatteryUsagePost } from "@/contract/generated/electrify-v1";
import { useFormContext } from "react-hook-form";
import { getSessionId } from "@/utils";

export const useBatteryOutlook = () => {
  const [loading, setLoading] = useState(false);
  const [batteryOutlook, setBatteryOutlook] = useState<IBatteryOutlook>({});
  const { getValues } = useFormContext();

  const billFrequency = getValues("billFrequency");
  const whenEnergyUsedMost = getValues("usagePattern");
  const winterExport = Number(getValues("winterGeneration"));
  const summerExport = Number(getValues("summerGeneration"));
  const sessionId = getSessionId();

  const doCalculation = async () => {
    setLoading(true);

    const data = await v1BatteryUsagePost(config.apiBasePath, {
      winterExport,
      summerExport,
      billFrequency,
      whenEnergyUsedMost,
      sessionId,
    });

    setBatteryOutlook({ data });
    setLoading(false);
  };

  useEffect(() => {
    doCalculation();
  }, []);

  return {
    loading,
    batteryOutlook,
  };
};
